import { multiCurrencyOptions } from './flyoutConstants'

export function getCurrencyCodeBySymbol(symbol: string): string | undefined {
  const currency = multiCurrencyOptions.find(option => option.symbol === symbol)
  return currency?.code
}
